/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetDocumentFilterResponseData,
  GetDocumentFilterResponseDataFromJSON,
  GetDocumentFilterResponseDataFromJSONTyped,
  GetDocumentFilterResponseDataToJSON
} from './GetDocumentFilterResponseData'

/**
 *
 * @export
 * @interface GetDocumentFilterResponse
 */
export interface GetDocumentFilterResponse {
  /**
   *
   * @type {number}
   * @memberof GetDocumentFilterResponse
   */
  status?: number
  /**
   *
   * @type {GetDocumentFilterResponseData}
   * @memberof GetDocumentFilterResponse
   */
  data?: GetDocumentFilterResponseData
}

export function GetDocumentFilterResponseFromJSON(json: any): GetDocumentFilterResponse {
  return GetDocumentFilterResponseFromJSONTyped(json, false)
}

export function GetDocumentFilterResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetDocumentFilterResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetDocumentFilterResponseDataFromJSON(json['data'])
  }
}

export function GetDocumentFilterResponseToJSON(value?: GetDocumentFilterResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetDocumentFilterResponseDataToJSON(value.data)
  }
}
